export class CheckboxRestrictions {
    constructor() {
        this.setupCheckboxRestrictions();
    }

    setupCheckboxRestrictions() {
        const groups = document.querySelectorAll('[class^="cvf_restrict-"]');

        groups.forEach(group => {
            const checkboxes = group.querySelectorAll('input[type="checkbox"]');
            const classList = Array.from(group.classList);
            const maxAllowed = classList
                .filter(className => className.startsWith('cvf_restrict-'))
                .map(className => parseInt(className.split('-')[1]))[0];

            checkboxes.forEach(checkbox => {
                checkbox.addEventListener('click', () => this.handleCheckboxClick(checkbox, checkboxes, maxAllowed));
            });
        });
    }

    handleCheckboxClick(clickedCheckbox, checkboxes, maxAllowed) {
        const selectedCheckboxes = Array.from(checkboxes).filter(cb => cb.checked);

        if (selectedCheckboxes.length > maxAllowed) {
            clickedCheckbox.checked = false;
        }
    }
}

const checkboxRestrictionsInstance = new CheckboxRestrictions();